import React from 'react'

const ContactUs = () => {
  return (
    <div className="contact-container">
      <h3>Address:</h3>
        <p className="address">
            No.37/38, Mallappa Layout, Seeghalli, K.R.Puram, Bangalore, Karnataka - 560049 IN
        </p>
        <h3>Email: </h3>
        <p className='email'>suyochi0623@gmail.com</p>
        <h3>Phone: </h3>
        <p className='email'>+91-9036712818</p>
        
        <h3>Google Map Location :</h3>
        <div className="map-container">
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3138.208644306908!2d77.71803867398816!3d13.01468218730464!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae110040de2531%3A0x334a69d974b75e01!2sSUYOCHI%20ROBOTICS!5e1!3m2!1sen!2sin!4v1747307041868!5m2!1sen!2sin" 
            width="100%" 
            height="300" 
            style={{border:0}} 
            allowfullscreen="" 
            loading="lazy" 
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
    </div>
  )
}

export default ContactUs
